module.exports = "pegasus_template/assets/email1-arrow.png";